import React, { useEffect, useRef, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GenericCarousel = ({ images }) => {
    const [index, setIndex] = useState(0);
    const { t } = useTranslation();

    const handleSelect = (selectedIndex, e) => {
        if (selectedIndex === index) return;

        setIndex(selectedIndex);
    };

    return (
        <>
            <Carousel
                activeIndex={index}
                className={`genericCarousel`}
                onSelect={handleSelect}
                prevIcon={
                    <FontAwesomeIcon icon="chevron-left" className="cortxt" />
                }
                nextIcon={
                    <FontAwesomeIcon icon="chevron-right" className="cortxt" />
                }
                indicators={false}
                interval={null}
            >
                {images &&
                    images?.map((image, i) => (
                        <Carousel.Item key={i}>
                            <div className="img-fluid imgCarousel d-inline-block">
                                <img
                                    alt={
                                        image.alt ??
                                        `${t('Imagem')}${
                                            i > 0 ? ` (${i})` : ''
                                        }`
                                    }
                                    src={image.src}
                                    className="img-fluid b-w1 b-solid b-cinza2 pad2 rad10"
                                />
                            </div>
                        </Carousel.Item>
                    ))}
            </Carousel>
            {/* custom indicators */}
            {(images?.length > 1 && (
                <div className={'customIndicatorsContainer mt-2'}>
                    {images?.map((image, i) => {
                        const isActiveIndicator = i === index;
                        return (
                            <div
                                key={i}
                                className={classnames('customIndicator', {
                                    ['border-tema']: isActiveIndicator,
                                })}
                                onClick={e => handleSelect(i, e)}
                            >
                                <img
                                    src={image.src}
                                    className="w-100 img-fluid b-w1 b-solid b-cinza2 pad2 rad10"
                                />
                            </div>
                        );
                    })}
                </div>
            )) || <div />}
            {/* custom indicators */}
        </>
    );
};
export default GenericCarousel;
